'use client';

import { articleStore } from '@/store/article';

import { StateArticle } from '@/models/States';

import ButtonLink, { ButtonLinkProps } from './links/ButtonLink';

export default function OpenArticleModal(props: ButtonLinkProps) {
  const { href, children, ...rest } = props;
  const updateStory = articleStore((store: StateArticle) => store.updateStory);

  return (
    <ButtonLink href={href} {...rest} onClick={() => updateStory(true)}>
      {children}
    </ButtonLink>
  );
}
